import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Feedback from '../../../../components/mui/Feedback';
import FormComponent from './FormComponent';
import { setFormData, setFormType, setIsOpenModal, setIsLoadingShow, setIsLoadingForm } from '../redux/actions/buildingAction';
import usePermission from '../../../../hooks/usePermission';
import { initialValuesBuilding as initialValues } from '../../../../helpers/variablesInitialValues';

const ModalComponent = () => {
	const dispatch = useDispatch();
	const isOpenModal = useSelector( ({ building }) => building.isOpenModal);
	const formType = useSelector( ({ building }) => building.formType);
	const permissionStore = usePermission('buildings.store');
	const permissionShow = usePermission('buildings.show');
	
	/**
	 *
	 * @description Execute reset formData, loading show, loading form, close modal state
	 * @return dispatch
	 *
	 */
	const handleCloseModal = async () => {
		await dispatch( setFormData(initialValues) );
		await dispatch( setFormType('') );
		await dispatch( setIsLoadingShow(false) );
		await dispatch( setIsLoadingForm(false) );
		await dispatch( setIsOpenModal(false) );
	};
	
	return (
		<Feedback.Modal
			maxWidth="md"
			isOpen={isOpenModal}
			isClose={handleCloseModal}
			title={formType === 'delete' ? `Eliminación de l edificación` : 'Captación de edificaciones'}
		>
			{(formType === 'store' || formType === 'show') && (
				(formType === 'store' ? permissionStore : permissionShow) && (
					<FormComponent />
				)
			)}
		</Feedback.Modal>
	);
};

export default ModalComponent;
